import axios from "axios"

export type GeoLocation = { address: string; point: { coordinates: [number, number]; type: string } }

export interface LocationAddress {
    address: string
    street?: string
    houseNumber?: string
    city?: string
    state?: string
    country?: string
    zipCode?: string
    coordinates: [number, number]
    placeType: Array<string>
    relevance: number
}

const GeoLocationService = {
    getPlacesAutocomplete: async (searchText: string) => {
        const { data = [] } = await axios.get<Array<GeoLocation>>(`/geo-location/places`, { params: { searchText } })
        return data
    },
    fetchDirections: async (coordinates: string) => {
        const { data } = await axios.get(`/geo-location/directions`, { params: { coordinates } })
        return data
    },
    fetchAddress: async (searchText: string, signal?: AbortSignal) => {
        const { data } = await axios.get<Array<LocationAddress>>(`/geo-location/address`, { params: { searchText }, signal })
        return data
    },
}

export default GeoLocationService
